import { combineReducers } from 'redux';
import { takeLatest, call, select } from 'redux-saga/effects';
import queryString from 'query-string';
import actionKey from '../utils/action-key';
import request from '../api-utils/request';
import subjectAreas from '../utils/subjectAreas';
import onetIDToSubjectArea from '../utils/occupationToSubjectArea';

export const FETCH_MILITARY_CROSSWALK = 'militaryCrosswalk/FETCH_MILITARY_CROSSWALK';
export const CHANGE_CROSSWALK_FILTER = 'militaryCrosswalk/CHANGE_CROSSWALK_FILTER';

const occupations = (state = {}, action) => {
    switch (action.type) {
        case actionKey.init(FETCH_MILITARY_CROSSWALK):
            return {};
        case actionKey.success(FETCH_MILITARY_CROSSWALK):
            return action.payload.occupations.reduce((acc, occupation) => {
                acc[occupation.occupationID_ONET] = {
                    ...occupation,
                    subjectAreaID: onetIDToSubjectArea[occupation.onetID],
                    subjectAreaName: subjectAreas[onetIDToSubjectArea[occupation.onetID]],
                };
                return acc;
            }, {});
        default:
            return state;
    }
};

const results = (state = null, action) => {
    switch (action.type) {
        case actionKey.init(FETCH_MILITARY_CROSSWALK):
            return [];
        case actionKey.success(FETCH_MILITARY_CROSSWALK):
            return action.payload.results;
        default:
            return state;
    }
};

const loading = (state = false, action) => {
    switch (action.type) {
        case FETCH_MILITARY_CROSSWALK:
            return true;
        case actionKey.success(FETCH_MILITARY_CROSSWALK):
        case actionKey.failure(FETCH_MILITARY_CROSSWALK):
            return false;
        default:
            return state;
    }
};

const error = (state = null, action) => {
    switch (action.type) {
        case FETCH_MILITARY_CROSSWALK:
        case actionKey.success(FETCH_MILITARY_CROSSWALK):
            return null;
        case actionKey.failure(FETCH_MILITARY_CROSSWALK):
            return action.error;
        default:
            return state;
    }
};

const welcome = (state = true, action) => {
    switch (action.type) {
        case FETCH_MILITARY_CROSSWALK:
            return false;
        default:
            return state;
    }
};

const filter = (state = {
    keyword: '',
    branch: 'air_force',
}, action) => {
    switch (action.type) {
        case CHANGE_CROSSWALK_FILTER:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default combineReducers({
    filter,
    occupations,
    results,
    error,
    loading,
    welcome,
});

export const fetchMilitaryCrosswalkAction = () => ({
    type: FETCH_MILITARY_CROSSWALK,
});

export const changeCrosswalkFilterAction = payload => ({
    type: CHANGE_CROSSWALK_FILTER,
    payload,
});

export function* rootSaga() {
    yield [
        takeLatest(FETCH_MILITARY_CROSSWALK, fetchMilitaryCrosswalk),
    ];
}

function* fetchMilitaryCrosswalk({ type }) {
    const {
        militaryCrosswalk,
    } = yield select();
    const params = queryString.stringify(militaryCrosswalk.filter);
    yield call(request, {
        url: `/api/career/military-crosswalk?${params}`,
        type,
    });
}



// WEBPACK FOOTER //
// ./src/client/redux/military-crosswalk.js